/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntSegmentsControllerGetSegmentsFaceRecognitionsByDateQueryResponse, PntSegmentsControllerGetSegmentsFaceRecognitionsByDatePathParams, PntSegmentsControllerGetSegmentsFaceRecognitionsByDateQueryParams } from "../models/PntSegmentsControllerGetSegmentsFaceRecognitionsByDate";

export function getPntSegmentsControllerGetSegmentsFaceRecognitionsByDateUrl(slug: PntSegmentsControllerGetSegmentsFaceRecognitionsByDatePathParams["slug"]) {
  const res = { method: 'GET', url: `/pnt/v2/segments/${slug}/facerecognition` as const }
  return res
}

/**
 * @summary Retrieve the face recognitions for a given time range
 * {@link /pnt/v2/segments/:slug/facerecognition}
 */
export async function pntSegmentsControllerGetSegmentsFaceRecognitionsByDate(slug: PntSegmentsControllerGetSegmentsFaceRecognitionsByDatePathParams["slug"], params: PntSegmentsControllerGetSegmentsFaceRecognitionsByDateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PntSegmentsControllerGetSegmentsFaceRecognitionsByDateQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getPntSegmentsControllerGetSegmentsFaceRecognitionsByDateUrl(slug).url.toString(), params, ... requestConfig })
  return res.data
}